export function tokenize(content) {
    const rawLines = content.split(/\r?\n/);
    // When the input uses CRLF line endings and ends with \r\n, the split
    // produces a spurious trailing empty string. Trim it so that N CRLF-
    // terminated lines yield exactly N TokenizedLine entries.
    const lines = content.endsWith('\r\n') && rawLines[rawLines.length - 1] === ''
        ? rawLines.slice(0, -1)
        : rawLines;
    const out = [];
    for (let i = 0; i < lines.length; i++) {
        const raw = lines[i] ?? '';
        const lineNumber = i + 1;
        // Strip mid-line ! comments (everything from ! to EOL).
        const bangIdx = raw.indexOf('!');
        const stripped = bangIdx >= 0 ? raw.slice(0, bangIdx) : raw;
        const trimmed = stripped.trim();
        if (bangIdx === 0) {
            out.push({
                kind: 'comment',
                lineNumber,
                raw,
                comment: raw.slice(1).trim(),
            });
            continue;
        }
        if (trimmed.length === 0) {
            out.push({ kind: 'blank', lineNumber, raw });
            continue;
        }
        if (trimmed.startsWith('#')) {
            out.push({ kind: 'option', lineNumber, raw: trimmed });
            continue;
        }
        if (trimmed.startsWith('[')) {
            out.push({ kind: 'keyword', lineNumber, raw: trimmed });
            continue;
        }
        // Numeric: try to parse all whitespace-separated tokens as numbers.
        const tokens = trimmed.split(/\s+/);
        const numbers = [];
        let malformed = false;
        for (const t of tokens) {
            const n = Number(t);
            if (!Number.isFinite(n)) {
                malformed = true;
                break;
            }
            numbers.push(n);
        }
        if (malformed) {
            out.push({
                kind: 'malformed',
                lineNumber,
                raw,
                reason: 'non-numeric token in data row',
            });
        }
        else {
            out.push({ kind: 'numeric', lineNumber, raw, numbers });
        }
    }
    return out;
}
//# sourceMappingURL=tokenize.js.map